/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { IrrServiceUserType } from './irrServiceUserType';


export interface IrrSddcTargetAccount { 
    type?: IrrServiceUserType;
    impersonate?: string;
}
export namespace IrrSddcTargetAccount {
}


